import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarHiddenLeftWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sidebar-hidden-left-wide"} maskId="square-filled-radius-0-stroke-1-IconSidebarHiddenLeftWide"><path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM5 7V17H6V7H5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSidebarHiddenLeftWide;
